export enum RoutePaths {
    Artists = 'artists',
    Browse = 'browse',
    Category = 'category',
    Charts = 'charts', // deprecated
    Collections = 'collections',
    Creator = 'creator', // deprecated
    CreatorBeatMaker = 'creator-beatmaker',
    Descriptors = 'descriptors', // deprecated
    Downloads = 'downloads',
    Exclusives = 'exclusives',
    Favorites = 'favorites',
    ForYou = '',
    Genres = 'genres',
    Instruments = 'instruments',
    KeyBpmFinder = 'key-bpm-finder',
    Labels = 'labels',
    Packs = 'packs',
    Plugin = 'plugin',
    Pricing = 'pricing',
    Profile = 'profile', // deprecated
    QuickPicks = 'quickpicks',
    Recommendations = 'recommendations',
    Sfxs = 'sfxs',
    UserCollections = 'my-collections',
}
